import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_CONTACT_APARTMENT_LOCATOR_BUTTON_CLICK } from 'api/actionTypes';

export default async function contactApartmentLocatorButtonClick({ apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  await apiClient.post(
    SR_API_ACTION_LISTING_CONTACT_APARTMENT_LOCATOR_BUTTON_CLICK,
    { listingId }
  );
}
